type Handler<EventMap, EventName extends keyof EventMap> = (event: EventMap[EventName]) => void;
type Opts = boolean | AddEventListenerOptions;
type HandlerList<EventMap, EventName extends keyof EventMap> = Array<
  [EventName, Handler<EventMap, EventName>, Opts?]
>;

// Registers a list of events to the given ref and returns their cleanup functions
export function registerEvents<EventName extends keyof WindowEventMap>(
  ref: Window,
  events: HandlerList<WindowEventMap, EventName>
);
export function registerEvents<EventName extends keyof DocumentEventMap>(
  ref: Document,
  events: HandlerList<DocumentEventMap, EventName>
);
export function registerEvents<EventName extends keyof HTMLElementEventMap>(
  ref: HTMLElement,
  events: HandlerList<HTMLElementEventMap, EventName>
);
export function registerEvents<EventName extends keyof HTMLMediaElementEventMap>(
  ref: HTMLMediaElement,
  events: HandlerList<HTMLMediaElementEventMap, EventName>
);
export function registerEvents(ref, events) {
  for (const [type, handler, options] of events) {
    ref.addEventListener(type, handler, options);
  }

  return () => {
    for (const [type, handler, options] of events) {
      ref.removeEventListener(type, handler, options);
    }
  };
}
